import { render, staticRenderFns } from "./PetlistView.vue?vue&type=template&id=16ae749f"
import script from "./PetlistView.vue?vue&type=script&lang=js"
export * from "./PetlistView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports